import { TaskStatus } from "../../vdo-ticket/services/TaskStatus";
import { TicketStateIds } from "../../vdo-ticket/services/TicketState";

/* Service class used to map workflowstateidentifiers to information 
 * needed for producing status badges */
class QueueWorkflowStateMapper {

    constructor() { 
        this.RecentlyCreatedStates = ["VDO_CREATED", "VDO_CREATED_C", "VDO_CREATED_RQ", "VDO_CREATED_RQC", "VIR_CREATED",
            "RTE_CREATED", "RTE_CREATED_C", "RTE_CREATED_RQ", "RTE_CREATED_RQC",
            "RTEDR_CREATED", "RTEDR_CREATED_C", "RTEDR_CREATED_RQ", "RTEDR_CREATED_RQC"];
        this.GatheringClientDataStates = [
            "VDO_CUSTOMER_ACTIONS", "VDO_CUSTOMER_ACTIONS_C", "VDO_CUSTOMER_ACTIONS_RQ", "VDO_CUSTOMER_ACTIONS_RQC",
            "VIR_CUSTOMER_ACTIONS", "VIR_CUSTOMER_ACTIONS_C",
            "RTE_CUSTOMER_ACTIONS", "RTE_CUSTOMER_ACTIONS_C", "RTE_CUSTOMER_ACTIONS_RQ", "RTE_CUSTOMER_ACTIONS_RQC",
            "RTEDR_CUSTOMER_ACTIONS", "RTEDR_CUSTOMER_ACTIONS_C", "RTEDR_CUSTOMER_ACTIONS_RQ", "RTEDR_CUSTOMER_ACTIONS_RQC"
        ]; 
        this.ReviewWithClientStates = [
            "RTEDR_DOCUMENT_REVIEW", "RTEDR_DOCUMENT_REVIEW_C", "RTEDR_DOCUMENT_REVIEW_RQ", "RTEDR_DOCUMENT_REVIEW_RQC"
        ];
        this.PrepareReturnStates = [
            "VDO_WORKING", "VDO_WORKING_C", "VDO_WORKING_RQ", "VDO_WORKING_RQC",
            "RTE_WORKING", "RTE_WORKING_C", "RTE_WORKING_RQ", "RTE_WORKING_RQC",
            "RTEDR_WORKING", "RTEDR_WORKING_C", "RTEDR_WORKING_RQ", "RTEDR_WORKING_RQC"
        ];
        this.ApprovalsPendingStates = [
            "VDO_REVIEW", "VDO_REVIEW_C", "VDO_REVIEW_RQC", "VDO_REVIEW_RQ",
            "VIR_REVIEW_RETURN", "VIR_REVIEW_RETURN_C",
            "RTE_REVIEW", "RTE_REVIEW_C", "RTE_REVIEW_RQC", "RTE_REVIEW_RQ", ,
            "RTEDR_REVIEW", "RTEDR_REVIEW_C", "RTEDR_REVIEW_RQC", "RTEDR_REVIEW_RQ"
        ];
        this.CreateInvoiceStates = [
            "RTE_PREPARE_PAYMENT", "RTE_PREPARE_PAYMENT_C", "RTE_PREPARE_PAYMENT_RQ", "RTE_PREPARE_PAYMENT_RQC",
            "RTEDR_PREPARE_PAYMENT", "RTEDR_PREPARE_PAYMENT_C", "RTEDR_PREPARE_PAYMENT_RQ", "RTEDR_PREPARE_PAYMENT_RQC"
        ]; 
        this.PaymentPendingStates = [
            "RTE_PAYMENT", "RTE_PAYMENT_C", "RTE_PAYMENT_RQ", "RTE_PAYMENT_RQC",
            "RTEDR_PAYMENT", "RTEDR_PAYMENT_C", "RTEDR_PAYMENT_RQ", "RTEDR_PAYMENT_RQC"
        ];      
        this.ReadyToFileStates = [
            "VDO_FILE", "VDO_FILE_C", "VDO_FILE_RQC", "VDO_FILE_RQ", 
            "VIR_FILE_RETURN", "VIR_FILE_RETURN_C", "VIR_CLIENT_CALL_PAYMENT", 
            "RTE_FILE", "RTE_FILE_C", "RTE_FILE_RQC", "RTE_FILE_RQ",
            "RTEDR_FILE", "RTEDR_FILE_C", "RTEDR_FILE_RQC", "RTEDR_FILE_RQ"
        ]; 
        this.CompletedStates = [
            "VDO_COMPLETE", "VDO_COMPLETE_C", "VDO_COMPLETE_RQC", "VDO_COMPLETE_RQ", 
            "VIR_COMPLETE", "VIR_COMPLETE_C", 
            "RTE_COMPLETE", "RTE_COMPLETE_C", "RTE_COMPLETE_RQ", "RTE_COMPLETE_RQC",
            "RTEDR_COMPLETE", "RTEDR_COMPLETE_C", "RTEDR_COMPLETE_RQ", "RTEDR_COMPLETE_RQC"
        ];
    }

    /**
     * Retrieves the selected page of tickets with the specified sort options
     * @param {any} workflowStateIdentifier
     */
    mapToWorkflowTask(workflowStateIdentifier, ticketStateId) {        
        if (ticketStateId === TicketStateIds.CLOSED) {
            return "QueuePage.SortTypes.Completed";
        } else if (ticketStateId === TicketStateIds.CLOSED_COMPLETED_IN_OFFICE) {
            return "QueuePage.SortTypes.ClosedCompletedInOffice";
        } else if (ticketStateId === TicketStateIds.CLOSED_INCOMPLETE) {
            return "QueuePage.SortTypes.ClosedUnableToComplete";
        } else if (this.CompletedStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.Completed";
        } else if (this.ReadyToFileStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.ReadyToFile";
        } else if (this.PaymentPendingStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.PaymentPending";
        } else if (this.CreateInvoiceStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.CreateInvoice";
        } else if (this.ApprovalsPendingStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.ApprovalsPending";
        } else if (this.PrepareReturnStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.PrepareReturn";
        } else if (this.ReviewWithClientStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.ReviewWithClient";
        } else if (this.GatheringClientDataStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.GatheringClientData";
        } else if (this.RecentlyCreatedStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.RecentlyCreated";
        } else {
            return null;
        }
    }

    /**
     * Retrieves the selected page of tickets with the specified sort options
     * @param {any} workflowStateIdentifier
     * @param {any} ticketStateId
     */
    mapToUnassignedWorkflowTask(workflowStateIdentifier, ticketStateId) {
        if (ticketStateId === TicketStateIds.CLOSED) {
            return "QueuePage.Closed.Complete"
        } else if (ticketStateId === TicketStateIds.CLOSED_COMPLETED_IN_OFFICE) {
            return "QueuePage.SortTypes.ClosedCompletedInOffice";
        } else if (ticketStateId === TicketStateIds.CLOSED_INCOMPLETE) {
            return "QueuePage.SortTypes.ClosedUnableToComplete";
        } else if (this.CompletedStates.includes(workflowStateIdentifier)) {
            return "QueuePage.SortTypes.Completed";
        } else if (this.RecentlyCreatedStates.includes(workflowStateIdentifier)) {
            return null;
        } else {
            return "QueuePage.SortTypes.ReadyToAssign";
        }
    }

    /**
     * Retrieves the status that should be used to display tickets in this workflow state
     * @param {any} workflowStateIdentifier
     */
    mapToStatus(workflowStateIdentifier, ticketStateId) {
        if (this.CompletedStates.includes(workflowStateIdentifier) ||
            ticketStateId === TicketStateIds.CLOSED_COMPLETED_IN_OFFICE) {
            return TaskStatus.COMPLETE;
        } else if (ticketStateId === TicketStateIds.CLOSED) {
            return TaskStatus.FAILED;
        } 
            
        return TaskStatus.IN_PROGRESS;
    }

    /**
     * Retrieves the status that should be used to display tickets in this workflow state
     * on the unassigned queue page
     * @param {any} workflowStateIdentifier
     */
    mapToUnassignedStatus(workflowStateIdentifier, ticketStateId) {
        if (ticketStateId === TicketStateIds.CLOSED || ticketStateId === TicketStateIds.CLOSED_COMPLETED_IN_OFFICE) {
            return TaskStatus.COMPLETE
        } else if (ticketStateId === TicketStateIds.CLOSED_INCOMPLETE) {
            return TaskStatus.IN_PROGRESS;
        } else if (this.RecentlyCreatedStates.includes(workflowStateIdentifier)) {
            return '';
        }
        return TaskStatus.IN_PROGRESS;
    }
}

const mapper = new QueueWorkflowStateMapper();
export default mapper;
